import router from '@/hotelcem/router'
import store from '@/xreports/store'
// import * as AppBaseConfigService from '@/storage/services/AppBaseConfigService'
import authService from '@/hotelcem/apis/auth/authService'
import { asyncRoutes, newAsyncRoutes } from '@/hotelcem/router/routes'
import { requestIdleCallback } from '@/utils/polyfill'
import storeCEM from '@/hotelcem/store/index'
import { getUserInfo, resetAppMenus, getAppBaseConfig } from '@/storage/services/AppBaseConfigService'
const STOR_LAST_ROUTES = 'LAST_ROUTES'
const ROUTES_INFO = 'ROUTES_INFO'
import dayjs from 'dayjs'
import { isEqual } from 'lodash'
import AuthService from '@hotelcem/apis/auth/authService'
import CommentListService from '@/hotelcem/apis/comment/commentListService'

class RoutesCacheManager {
  constructor(capacity) {
    this.capacity = capacity
    this.cache = new Map()
    this.loadFromStorage()
  }

  loadFromStorage() {
    const cached = localStorage.getItem(ROUTES_INFO)
    if (cached) {
      try {
        const cachedRoutes = JSON.parse(cached)
        cachedRoutes.forEach(route => {
          this.cache.set(route.key, route)
        })
      } catch (error) {
        console.error('Error parsing cached routes:', error)
      }
    } else {
      this.transformRoutes()
    }
  }

  transformRoutes() {
    const allKeys = Object.keys(localStorage)
    allKeys.forEach(key => {
      if (key.startsWith(STOR_LAST_ROUTES)) {
        const value = JSON.parse(localStorage.getItem(key))
        this.setRoute(key, value, false)
        localStorage.removeItem(key)
      }
    })
    this.saveToStorage()
  }

  saveToStorage() {
    const dataToStore = Array.from(this.cache.values())
    localStorage.setItem(ROUTES_INFO, JSON.stringify(dataToStore))
  }
  setRoute(key, value, needSave = true) {
    if (this.cache.has(key)) {
      this.cache.delete(key)
    } else if (this.cache.size >= this.capacity) {
      this.cache.delete(this.cache.keys().next().value)
    }
    this.cache.set(key, {
      key: key,
      value: value,
    })
    needSave && this.saveToStorage()
  }

  getRoute(key) {
    if (!this.cache.has(key)) {
      return null
    }
    const route = this.cache.get(key)
    this.setRoute(key, route.value)
    return route.value
  }
}
/**
 * 将菜单权限集合转成Map
 * @param {Array} roles 菜单权限集合
 * @returns
 */
function rolesToMap(roles = []) {
  return roles.reduce((obj, role) => {
    if (role?.children?.length) {
      obj = {
        ...obj,
        ...rolesToMap(role.children),
      }
    }

    if (role.name.includes('华客') && store.state.app.corpName !== '华客') {
      role.name = role.name.replace(/华客/i, store.state.app.corpName)
    }

    obj[role.code] = role
    return obj
  }, {})
}

function sortRoutes(routes) {
  if (!routes || !routes.length) return routes

  // 对当前层级的 routes 进行排序
  routes.sort((a, b) => a.sort - b.sort)

  // 递归对每个 route 的 children 进行排序
  routes.forEach(route => {
    if (route.children && route.children.length) {
      route.children = sortRoutes(route.children)
    }
  })

  return routes
}
/**
 * 过滤没有权限的routes
 * @param routes asyncRoutes
 * @param roles
 */
function filterAsyncRoutes(routes = [], rolesMap) {
  let res = []
  for (const route of routes) {
    if (route.children?.length) {
      route.children = filterAsyncRoutes(route.children, rolesMap)
      if (route.children?.length) {
        route.redirect = route.children[0].path
      }
    }
    if (rolesMap[route.name]) {
      res.push(route)
    }
  }
  return res
}
function getLastRoutesStorKey(menuVersion) {
  let account = localStorage.getItem('VOCUST_APP_BASE_ID')
    ? JSON.parse(localStorage.getItem('VOCUST_APP_BASE_ID')).userInfo?.account
    : ''
  return STOR_LAST_ROUTES + '_' + getAppBaseConfig().appName + '_' + account + '_' + menuVersion
}
/**
 * 过滤不需要显示的菜单
 * @param routes asyncRoutes
 * @param roles
 */
function filterMenuList(routes, menuVersion) {
  //在这一步，要把info2内的board菜单拿出来
  const menuList = []
  if (routes?.length) {
    for (const route of routes) {
      if (route.positionName === 'hide' && menuVersion === 1) {
        continue
      }
      menuList.push({
        code: route.code, // 唯一key
        path: route.path, // 路由地址
        name: route.name, // 路由名称
        alias: route.alias, // 英文名
        children: filterMenuList(route.children, menuVersion),
        source: route.source,
        remark: route.remark,
        id: route.id,
        positionName: route.positionName,
      })
    }
  }
  return menuList
}

const getUrlParam = key => {
  var reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)') //构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg) //匹配目标参数
  if (r != null) {
    return unescape(r[2]) //返回参数值
  } else {
    return null
  }
}

async function processingMenu(menus) {
  const urlHotelId = getUrlParam('hotelId')
  const res = await AuthService.getHotelInfo({ hotelId: urlHotelId })
  console.log('a2222', res)
  return menus
}

const getStoreMenuVersion = () => {
  const userInfo = getUserInfo()
  if (!userInfo?.account) return 1
  const cacheMenuVersion = localStorage.getItem(`menuVersion_${userInfo.account}`)
  console.log(cacheMenuVersion, 'cacheMenuVersion')
  return cacheMenuVersion ? Number(cacheMenuVersion) : 1
}
/**
 * CEM菜单管理Store
 */
export default {
  namespaced: true,
  state: {
    // 菜单是否已经初始化
    initialized: false,
    // 菜单列表
    menuList: [],
    // 接口返回原始数据
    menuRoutes: [],
    menuVersion: getStoreMenuVersion(),
    asyncFlag: false,
    systemModules: [],
  },
  mutations: {
    SET_MENU_ROUTES(state, payload) {
      state.menuRoutes = payload
    },
    SET_MENU_INITIALIZED(state, payload) {
      state.initialized = payload
    },
    SET_MENU_LIST(state, payload) {
      state.menuList = payload
      resetAppMenus(payload)
    },
    SET_MENU_VERSION(state, payload) {
      const menuVersion = store.getters.deviceMode === 'mobile' ? 1 : payload
      state.menuVersion = menuVersion
      const userInfo = getUserInfo()
      const key = `menuVersion_${userInfo?.account}`
      localStorage.setItem(key, payload)
    },
    SET_ASYNC_FLAG(state, payload) {
      state.asyncFlag = payload
    },
    SET_SYSTEM_MODULES(state, payload) {
      state.systemModules = payload
    },
  },
  actions: {
    /**
     * 初始化系统菜单和添加异步菜单逻辑, 仅在vue-router中调用一次
     * @param {Object} StoreContext
     */
    async initMenuList({ commit, state, rootState }, params) {
      let _requestIdleCallback = requestIdleCallback
      if (state.initialized) {
        return
      }
      const routesManager = new RoutesCacheManager(10)
      const lastMenuStorKey = getLastRoutesStorKey(state.menuVersion)
      let routesCached = routesManager.getRoute(lastMenuStorKey) //key加个手机号
      console.log(lastMenuStorKey, routesCached, 'lastMenuStorKey')
      let accessedRoutes, routesMap, menuList
      // routesCached = false
      if (routesCached) {
        // const oldHotelInfo = JSON.parse(localStorage.getItem('VOCUST_HOTEL_CEM_FILTER_KEY'))
        // const tenantId = getUserInfo()?.tenantId
        // if (oldHotelInfo && tenantId === oldHotelInfo.hotelInfo.hotelInfo.tenantId) {
        //   if (oldHotelInfo.dateRange.length > 0) {
        //     let sd = dayjs(oldHotelInfo.dateRange[0]).hour(0).minute(0).second(0).millisecond(0).toDate()
        //     let ed = dayjs(oldHotelInfo.dateRange[1]).hour(23).minute(59).second(59).millisecond(999).toDate()
        //     oldHotelInfo.dateRange = [sd, ed]
        //   }

        //   storeCEM.commit('common/SET_DATE_FILTER', oldHotelInfo)
        // }
        const baseRoutes = state.menuVersion === 1 ? asyncRoutes : newAsyncRoutes
        routesMap = rolesToMap(routesCached)
        accessedRoutes = filterAsyncRoutes(baseRoutes, routesMap)
        // if (accessedRoutes?.length) {
        //   accessedRoutes.push({ path: '/', redirect: accessedRoutes[0].path })
        //   accessedRoutes.push({ path: '*', redirect: accessedRoutes[0].path })
        // }
        const homeRoute = accessedRoutes.find(item => item.name === 'HOTEL-CEM-HOME' || item.path === '/home')
        if (!homeRoute) {
          //如果没有开通语音模块，设置 舆情管理--点评整体分析 为首页
          const commentAnalysis = accessedRoutes.find(item => item.name === 'COMMENT-ANALYSIS-INDEX')
          if (commentAnalysis) {
            accessedRoutes.push({ path: '/', redirect: commentAnalysis.path })
            accessedRoutes.push({ path: '*', redirect: commentAnalysis.path })
          }
        } else if (accessedRoutes?.length) {
          accessedRoutes.push({ path: '/', redirect: accessedRoutes[0].path })
          accessedRoutes.push({ path: '*', redirect: accessedRoutes[0].path })
        }
        router.addRoutes(accessedRoutes)
        menuList = filterMenuList(routesCached, state.menuVersion)
        commit('SET_MENU_ROUTES', routesCached)
        commit('SET_MENU_LIST', menuList)
        commit('SET_MENU_INITIALIZED', true)
        // return
      } else {
        //如果没有缓存，则切换成串行加载路由
        _requestIdleCallback = async callback => {
          await callback()
        }
      }
      return await _requestIdleCallback(async () => {
        try {
          const param = params
            ? {
                menuVersion: params.menuVersion,
              }
            : {}
          const res = await authService.getRoutes(param)
          if (res.code === 200) {
            let routes = res.data

            // debugger
            // if (store.state.app.corpName !== '华客') {
            //   routes = JSON.parse(JSON.stringify(routes).replace(/华客/g, store.state.app.corpName))
            // }
            if (!routes?.length) {
              store.dispatch('systemUser/logout')
              return
            }
            const menuVersion = routes[0]?.menuVersion || state.menuVersion
            menuVersion === 2 && (routes = sortRoutes(routes))
            routesMap = rolesToMap(routes)
            console.log(state.menuVersion, 'lastMenuStorKey')
            _requestIdleCallback(() => {
              const key = getLastRoutesStorKey(state.menuVersion)
              console.log(key, routes, 'lastMenuStorKey')
              routesManager.setRoute(key, routes)
            })
            const baseRoutes = menuVersion === 1 ? asyncRoutes : newAsyncRoutes
            const accessedRoutes = filterAsyncRoutes(baseRoutes, routesMap)
            const homeRoute = accessedRoutes.find(item => item.name === 'HOTEL-CEM-HOME' || item.path === '/home')
            if (!homeRoute) {
              //如果没有开通语音模块，设置 舆情管理--点评整体分析 为首页
              const commentAnalysis = accessedRoutes.find(item => item.name === 'COMMENT-ANALYSIS-INDEX')
              if (commentAnalysis) {
                accessedRoutes.push({ path: '/', redirect: commentAnalysis.path })
                accessedRoutes.push({ path: '*', redirect: commentAnalysis.path })
              }
            } else if (accessedRoutes?.length) {
              accessedRoutes.push({ path: '/', redirect: accessedRoutes[0].path })
              accessedRoutes.push({ path: '*', redirect: accessedRoutes[0].path })
            }

            router.addRoutes(accessedRoutes)

            menuList = filterMenuList(routes, menuVersion)
            commit('SET_MENU_ROUTES', routes)
            commit('SET_MENU_LIST', menuList)
          }
        } catch (error) {
          store.dispatch('systemUser/logout')
          console.error(error)
        } finally {
          commit('SET_MENU_INITIALIZED', true)
          commit('SET_ASYNC_FLAG', true)
        }
      })
    },

    async getSystemModules({ commit, state, rootState }) {
      try {
        const res = await CommentListService.getSystemList()
        if (res.successful) {
          const newList = res.data || []
          if (!isEqual(newList, state.systemModules)) {
            commit('SET_SYSTEM_MODULES', res.data)
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
  },
}
